import axios from 'axios';
import md5 from 'md5';

const handleAdminError = (error) => {
    const status = error?.response?.status;

    if (status === 401)  {
        localStorage.removeItem('token');
        return window.location.href = '/';
    } else if (status === 404) {
        return window.location.href = '/404';
    }

    return error?.response ?? {
        status: 500,
        data: {
            message: error?.message || 'Something went wrong.',
        },
    };
}

export const login = (payload) => {
    payload.password = md5(payload.password);
    
    return axios.post(`${process.env.REACT_APP_API}/authenticate`, payload)
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        return error?.response?.status ?? 500;
    });
}

export const getList = (token, payload) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.post(`${process.env.REACT_APP_API}/admin-management/list`, payload, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        return handleAdminError(error);
    });
}

export const getSalesPeople = (token) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.get(`${process.env.REACT_APP_API}/sales-person/list`, { headers })
    .then(function(response) {
        return response.data;
    });
}

export const create = (token, payload) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
    
    if (payload.password) {
        payload.password = md5(payload.password);
    } else {
        delete payload.password;
    }

    return axios.post(`${process.env.REACT_APP_API}/admin-management`, payload, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        return handleAdminError(error);
    });
}


export const getInformation = (token, id) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.get(`${process.env.REACT_APP_API}/admin-management/${id}`, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        return handleAdminError(error);
    });
}

export const update = (token, payload, id) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    if (payload.password) {
        payload.password = md5(payload.password);
    } else {
        delete payload.password;
    }

    return axios.patch(`${process.env.REACT_APP_API}/admin-management/${id}`, payload, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        return handleAdminError(error);
    });
}
